/**
 * Hybrid Collapsible Component
 *
 * Collapsible exposes no styled-system props, so a `hasStyledProps` branch would
 * be dead code. This Hybrid is a thin passthrough to the Tailwind implementation,
 * kept for parity with the other migrated components. The compound
 * `.Trigger` / `.Panel` API is carried through unchanged.
 */

import CollapsibleTailwind from "./CollapsibleTailwind";

const Collapsible = CollapsibleTailwind;

export default Collapsible;
